"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasMultiRegistrationWorkflow = void 0;
const Types_1 = require("./Types");
const CanvasWorkflow_1 = require("./CanvasWorkflow");
const validation_1 = require("./validation/validation");
class CanvasMultiRegistrationWorkflow extends CanvasWorkflow_1.CanvasWorkflow {
  constructor() {
    super();
    this.inputPin = [Types_1.InputPin.INPUT];
    this.outputPin = [Types_1.OutputPin.OUTPUT, Types_1.OutputPin.SUBPARTICIPANT_OUTPUT, Types_1.OutputPin.CANCELLATION_OUTPUT];
    this.type = Types_1.WorkflowType.MULTI_REGISTRATION;
    this.settings = this.getDefaultSettings();
    this.customProcess = {
      mainparticipant_registration_after_actions: null,
      mainparticipant_engagement_sequence: null,
      subparticipant_registration_after_actions: null
    };
    this.schema = validation_1.MultiRegistrationSchema;
  }
  getDefaultSettings() {
    return {
      multiregistration_type: 'ticket',
      form_id: null,
      thank_you_page_id: null,
      multiregistration_limit: 0,
      multiregistration_limit_field_id: null,
      mainparticipant_assigned_required: false,
      unassigned_tickets_allowed: false,
      subparticipant_form_field_ids: [],
      mainparticipant_confirmation_email_campaign_id: null,
      subparticipant_confirmation_email_campaign_id: null,
      mainparticipant_registration_pending_stage_name: '',
      mainparticipant_registration_completed_stage_name: '',
      subparticipant_registration_pending_stage_name: '',
      subparticipant_registration_completed_stage_name: '',
      cancellation_workflow_id: null,
      next_workflow_ids: {
        next_workflow: null,
        subparticipant_workflow: null
      }
    };
  }
  setNextWorkflow(pin, next_workflow_id) {
    if (pin === Types_1.OutputPin.SUBPARTICIPANT_OUTPUT) {
      this.settings.next_workflow_ids.subparticipant_workflow = next_workflow_id;
      return;
    }
    if (pin === Types_1.OutputPin.CANCELLATION_OUTPUT) {
      this.settings.cancellation_workflow_id = next_workflow_id;
    }
    this.setDefaultNextWorkflow(pin, next_workflow_id);
  }
  getNextWorkflows() {
    const o = {};
    o[Types_1.OutputPin.OUTPUT] = this.getDefaultNextWorkflow();
    o[Types_1.OutputPin.SUBPARTICIPANT_OUTPUT] = this.settings.next_workflow_ids.subparticipant_workflow;
    o[Types_1.OutputPin.CANCELLATION_OUTPUT] = this.settings.cancellation_workflow_id;
    return o;
  }
  setCustomProcess(s, p) {
    switch (s) {
      case 'mainparticipant_registration_after_actions':
        this.customProcess.mainparticipant_registration_after_actions = p;
        break;
      case 'mainparticipant_engagement_sequence':
        this.customProcess.mainparticipant_engagement_sequence = p;
        break;
      case 'subparticipant_registration_after_actions':
        this.customProcess.subparticipant_registration_after_actions = p;
        break;
      default:
    }
  }
  getProperties() {
    return [{
      attribute: 'form_id',
      datasource: 'Form',
      label: 'FORMS',
      type: 'select',
      mandatory: true,
      value: this.settings.form_id
    }, {
      attribute: 'thank_you_page_id',
      datasource: 'Page',
      label: 'THANK_YOU_PAGE',
      type: 'select',
      mandatory: true,
      value: this.settings.thank_you_page_id
    }, {
      attribute: 'multiregistration_type',
      label: 'MULTI_REGISTRATION_TYPE',
      type: 'select',
      datasource: 'Options',
      options: [{
        label: 'TICKET',
        value: 'ticket'
      }, {
        label: 'GROUP',
        value: 'group'
      }],
      mandatory: true,
      value: this.settings.multiregistration_type
    }, {
      attribute: 'multiregistration_limit',
      datasource: null,
      label: 'MULTI_REGISTRATION_LIMIT',
      type: 'number',
      mandatory: false,
      value: this.settings.multiregistration_limit
    }, {
      attribute: 'multiregistration_limit_field_id',
      datasource: 'IntegerField',
      label: 'MULTI_REGISTRATION_LIMIT_FIELD',
      type: 'select',
      mandatory: false,
      value: this.settings.multiregistration_limit_field_id
    }, {
      attribute: 'mainparticipant_assigned_required',
      datasource: null,
      label: 'MAINPARTICIPANT_ASSIGNED_REQUIRED',
      type: 'boolean',
      mandatory: false,
      value: this.settings.mainparticipant_assigned_required
    }, {
      attribute: 'unassigned_tickets_allowed',
      datasource: null,
      label: 'UNASSIGNED_TICKETS_ALLOWED',
      type: 'boolean',
      mandatory: false,
      value: this.settings.unassigned_tickets_allowed
    }, {
      attribute: 'subparticipant_form_field_ids',
      datasource: 'Field',
      label: 'SUBPARTICIPANT_FORM_FIELDS',
      type: 'multiselect',
      mandatory: false,
      value: this.settings.subparticipant_form_field_ids
    }, {
      attribute: 'mainparticipant_confirmation_email_campaign_id',
      datasource: 'Email',
      label: 'MAINPARTICIPANT_CONFIRMATION_EMAIL',
      type: 'select',
      mandatory: false,
      value: this.settings.mainparticipant_confirmation_email_campaign_id
    }, {
      attribute: 'subparticipant_confirmation_email_campaign_id',
      datasource: 'Email',
      label: 'SUBPARTICIPANT_CONFIRMATION_EMAIL',
      type: 'select',
      mandatory: false,
      value: this.settings.subparticipant_confirmation_email_campaign_id
    }, {
      attribute: 'mainparticipant_registration_pending_stage_name',
      datasource: null,
      label: 'MULTIREGISTRATION_PENDING_STAGE',
      type: 'text',
      mandatory: false,
      value: this.settings.mainparticipant_registration_pending_stage_name
    }, {
      attribute: 'mainparticipant_registration_completed_stage_name',
      datasource: null,
      label: 'MULTIREGISTRATION_COMPLETED_STAGE',
      type: 'text',
      mandatory: false,
      value: this.settings.mainparticipant_registration_completed_stage_name
    }, {
      attribute: 'subparticipant_registration_pending_stage_name',
      datasource: null,
      label: 'MULTIREGISTRATION_REGISTRATION_PENDING_STAGE',
      type: 'text',
      mandatory: false,
      value: this.settings.subparticipant_registration_pending_stage_name
    }, {
      attribute: 'subparticipant_registration_completed_stage_name',
      datasource: null,
      label: 'MULTIREGISTRATION_REGISTRATION_COMPLETED_STAGE',
      type: 'text',
      mandatory: false,
      value: this.settings.subparticipant_registration_completed_stage_name
    }];
  }
}
exports.CanvasMultiRegistrationWorkflow = CanvasMultiRegistrationWorkflow;
